import React, { FC } from 'react';
import { CopyToClipboardButton } from 'app/components/utilities/CopyToClipboard';
import { Size } from 'app/components/presentation/buttons/ButtonClassNameA';
import { useI18n } from 'app/components/localization';
import { useBookingState } from 'app/containers/rtc/BookingContext/BookingState';
import { useMeetingUrl } from 'app/components/call/BookingDetails/MeetingBookingDetails/CopyMeetingLink';
import { BookingType } from 'app/models/rtc/booking/constants';
import NavigationItem from 'app/components/header/navigation/NavigationItem';

/**
 * A reusable component that renders a copy link button when in a meeting..
 * Should only be used in header.
 */
const CopyMeetingLinkNavigationItem: FC = () => {
  const { t } = useI18n();
  const bookingState = useBookingState();
  const meetingUrl = useMeetingUrl(bookingState);

  const isMeetingBooking = bookingState?.bookingType === BookingType.Meeting;

  if (!isMeetingBooking || !meetingUrl) {
    return null;
  }

  return (
    <NavigationItem>
      <CopyToClipboardButton
        fullWidth
        value={meetingUrl}
        label={t('header.copy-link.copy')}
        copiedMessage={t('header.copy-link.copied')}
        size={Size.Tiny}
      />
    </NavigationItem>
  );
};

export default CopyMeetingLinkNavigationItem;
